// extracted by mini-css-extract-plugin
export default {"title":"tileTitle_title__MrxEM"};